import type { FilingStatus } from './filingStatus'

// Canonical sort order for the 4 IRS filing statuses. Alphabetical by the
// human-readable label — matches historic ordering used across all
// dictionary tables (federal brackets, state brackets, standard deductions)
// and downstream tests. Explicit `<`/`>` avoids the locale-sensitivity of
// `String.prototype.localeCompare`.
export const compareFilingStatuses = (
  a: FilingStatus,
  b: FilingStatus
): number => (a < b ? -1 : a > b ? 1 : 0)
